<template v-if="colName && dbName && colSize">
    <div class="row g-3 align-items-center">
        <div class="col-auto">
            <label for="search" class="col-form-label">按名称搜索</label>
        </div>
        <div class="col-5 col-sm-3 col-lg-2">
            <input type="search" v-model="formReg" @keyup.enter="queryDocsByReg()" class="form-control">
        </div>
        <div class="col-auto">
            <button type="submit" @click="queryDocsByReg()" class="btn btn-primary">搜索</button>
        </div>
    </div>
    <div class="row g-3 align-items-center">
        <div class="col-auto">
            <label for="search" class="col-form-label">按id搜索</label>
        </div>
        <div class="col-5 col-sm-3 col-lg-2">
            <input type="search" v-model="formId" @keyup.enter="queryDocsById()" class="form-control">
        </div>
        <div class="col-auto">
            <button type="submit" @click="queryDocsById()" class="btn btn-primary">搜索</button>
        </div>
    </div>
    <div class="row g-3 align-items-center">
        <div class="col-auto">
            <label for="search" class="col-form-label">按id范围搜索</label>
        </div>
        <div class="col-5 col-sm-3 col-lg-2">
            <Slider v-model="formRange" :min="1" :max="colSize"></Slider>
        </div>
        <div class="col-auto">
            <button type="submit" @click="queryDocsByRange()" class="btn btn-primary">搜索</button>
        </div>
    </div>
    <!-- <div class="row flex-grow-1" style="overflow-y: auto; height: 450px;"> -->
    <div class="row flex-grow-1" style="overflow-y: auto; height: 60vh;">
        <DocAccordion :dbName="dbName" :colName="colName" :accordionList="docList"></DocAccordion>        
    </div>
</template>
  
<script>
import axios from "@/utils/http"
import DocAccordion from "./DocAccordion.vue"
import Slider from '@vueform/slider'

export default {
    name: 'CommonQuery',
    components: {
        DocAccordion,
        Slider,
    },
    data() {
        return {
            formRange: [],
            formId: undefined,
            formReg: "",
            docList: [],
        }
    },
    props: ['colName', 'dbName', 'colSize'],
    methods: {
        queryDocsByReg() {
            // if(this.formReg[colName] === undefined){this.formReg[colName] = ''}
            axios.post('/' + this.dbName + '/' + this.colName, { reg: this.formReg })
                .then(response => { this.docList = [].concat(response.data) })
            // this.formReg = {}
        },
        queryDocsById() {
            axios.post('/' + this.dbName + '/' + this.colName, { docId: this.formId })
                .then(response => { this.docList = [].concat(response.data) })
            // this.formId = {}
        },
        queryDocsByRange() {
            console.log(this.formRange)
            axios.post('/' + this.dbName + '/' + this.colName, { range: [this.formRange[0] - 1, this.formRange[1]] })
                .then(response => { this.docList = [].concat(response.data) })
            // this.formId = {}
        },
    },
    created() {
        this.formRange = [1, this.colSize]
    }
}
</script>
  
<style src="@vueform/slider/themes/default.css"></style>